import React from 'react';
import ReactDOM from 'react-dom/client';
import { Toaster } from 'react-hot-toast';
import { Provider } from 'react-redux';
import { AuthProvider } from 'src/contexts/AuthContext';
import { MobileRotationProvider } from 'src/contexts/MobileRotationContext';
import App from './app';
import './index.css';
import { store } from './store/index';
import ApplicationErrorBoundary from './components/ApplicationErrorBoundary';
import BrandedApplicationErrorBoundary from './components/BrandedApplicationErrorBoundary';
import { initAnalytics } from './services/analytics';

initAnalytics();

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
  <ApplicationErrorBoundary context="root-last-resort">
    <Provider store={store}>
      <BrandedApplicationErrorBoundary>
        <AuthProvider>
          <MobileRotationProvider>
            <Toaster toastOptions={{ duration: 3000 }} position="bottom-left" />
            <App />
          </MobileRotationProvider>
        </AuthProvider>
      </BrandedApplicationErrorBoundary>
    </Provider>
  </ApplicationErrorBoundary>
);
